<template>
    <div>
        <el-image :src="logoImg">
            <div slot="error" class="image-slot">
                <img :src="imageUrl" alt="">
            </div>
        </el-image>
    </div>
</template>
<script>
export default {
  name: "component_name",
  data() {
    return {
      imageUrl: `https://lyn.oss-cn-shenzhen.aliyuncs.com/temp/airline-blank-map.jpg`
    };
  },
  props: {
    logoImg: ""
  },
  methods: {}
};
</script>
<style lang="less" scoped>
/deep/.el-image {
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    border-right: 50%;
    margin-left: 13px;
  }
}
</style>